module.exports = __webpack_public_path__ + "wax-print.png?836049d825c838742526288f3e4d7348";